module.exports = __webpack_public_path__ + "img/setting-step-one.95ebeecc.png";